export default "__VITE_ASSET__Dlf6r7hT__"